
import ReturnToTheOldVersion from '../../../components/ReturnToTheOldVersion'
import { apiRequest } from '../../apiCall'
import { VoiceMailUrlPayloadType } from '../../interfaces/voiceMail'
import { VoiceMailOperationsRequest, voiceMailRequest } from '../../types/voiceMail/apiRequestTypes'


export const getInboxVoicemailsByFilter = (params: voiceMailRequest) => apiRequest('Voicemail.GetInboxVoicemailsByFilter', params, '', true)
export const setHeardByVoicemailId = (params: VoiceMailOperationsRequest) => apiRequest('Voicemail.SetHeardByVoicemailId', {}, `?RecordingId=${params.RecordingId}&Heard=${params.Heard}`, true)
export const moveToTrash = (params: VoiceMailOperationsRequest) => apiRequest('Voicemail.MoveToTrash', {}, `?RecordingId=${params.RecordingId}&IsDeleted=true`, true)
export const getAudioFile = (params: VoiceMailOperationsRequest) => apiRequest('Voicemail.GetAudioFile', {}, `?RecordingId=${params.RecordingId}&Heard=${params.Heard}`, true)
export const getVoiceMailBoxes = (params: string) => apiRequest('Voicemail.GetVoicemailBoxes', {}, '', true)
export const insertVoicemailUrlRequest = (params: VoiceMailUrlPayloadType) => apiRequest('CustomerLine.insertVoicemailUrl', {}, `?CustomerLineId=${params.lineId}&url=${params.url}`, true)
export const getVoicemailUrlRequest = (lineId: string) => apiRequest('CustomerLine.getVoicemailUrl', {}, `?CustomerLineId=${lineId}`, true)





